






































import { Cirus } from "@/classes/Http";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class ForgotPasswordForm extends Vue {
  user= {
    mobile: "",
    password: "",
  };
  level= 0;
  loading= false;
  counter= 60;
  interval: any = null;
  next= '/';
  
  async login() {
      if (!this.user.mobile || this.user.mobile == '') {
        this.$message({
          showClose: true,
          message: "لطفا شماره تماس را صحیح وارد کنید.",
          type: "error",
          duration: 5000,
        });
        this.loading = false;
        return;
      }
      this.user.mobile = this.user.mobile.trim();
      this.user.mobile = this.user.mobile.replace(/۰/g, '0');
      this.user.mobile = this.user.mobile.replace(/۱/g, '1');
      this.user.mobile = this.user.mobile.replace(/۲/g, '2');
      this.user.mobile = this.user.mobile.replace(/۳/g, '3');
      this.user.mobile = this.user.mobile.replace(/۴/g, '4');
      this.user.mobile = this.user.mobile.replace(/۵/g, '5');
      this.user.mobile = this.user.mobile.replace(/۶/g, '6');
      this.user.mobile = this.user.mobile.replace(/۷/g, '7');
      this.user.mobile = this.user.mobile.replace(/۸/g, '8');
      this.user.mobile = this.user.mobile.replace(/۹/g, '9');
      this.user.mobile = this.user.mobile.replace(/\D/g,'');
      try {
        await Cirus.sendMobileVerification(this.user.mobile);
        this.level = 1;
        this.interval = setInterval(()=>{this.start_counting()}, 1000);
      } catch {
        this.$message({
          showClose: true,
          message: "لطفا شماره تماس را صحیح وارد کنید.",
          type: "error",
          duration: 5000,
        });
      } finally {
        this.loading = false;
      }
    }
    async verify() {
      this.loading = true;
      try {
        let res = await Cirus.verifyPassword(this.user.mobile, this.user.password);
        if (
          typeof res.data.access_token == "undefined" ||
          !res.data.access_token
        ) {
          this.$message({
            showClose: true,
            message: "لطفا رمز را صحیح وارد کنید.",
            type: "error",
            duration: 5000,
          });
        } else {
          this.$store.commit("setUserToken", res.data.access_token);
          this.$store.commit("setRoles", res.data);
          this.$store.dispatch('auth');
          // this.$router.push("/");
          setTimeout(() => {
            if (this.next&&this.next.charAt(0) === '/') this.$router.replace(this.next)
            else window.location.href = this.next;
          }, 1000);
        }
      } catch (err) {
        console.log(err);
        this.$message({
          showClose: true,
          message: "لطفا رمز را صحیح وارد کنید.",
          type: "error",
          duration: 5000,
        });
      } finally {
        this.loading = false;
      }
      this.loading = false;
    }

    handleFormSubmit(event: Event) {
      if (event) event.preventDefault()
      this.loading = true;
      if (this.level == 0) {
        this.login();
      } else {
        this.verify();
      }
    }

    start_counting() {
      --this.counter;
      if (this.counter <= 0) {
        this.counter = 0;
        clearInterval(this.interval);
      }
    }

  mounted() {
    const query = this.$route.query;
    // this.$router.replace({query: {}})
    this.user.mobile = query.mobile as string || "";
    if (typeof query.next=='string'&&query.next.length>0) this.next = query.next;
  }
}
